import React from 'react'
import './stepTextHistory.css'
import { Typography } from '@airbus/components-react/components'

const StepTextHistory = (props) => {
  const data = props.data
  const isStartPoint = props.isStartPoint

  return (
    <div className='valcde_step_textHistory'>
      {isStartPoint ? (
        <div style={{ width: '50px' }}>
          {data
            ? data.map((d) => (
                <Typography key={d} style={{ marginLeft: '-50px' }}>
                  {d}
                </Typography>
              ))
            : ''}
        </div>
      ) : (
        <div style={{ width: '100px' }}>{data ? data.map((d) => <Typography key={d}>{d}</Typography>) : ''}</div>
      )}
    </div>
  )
}

export default StepTextHistory
